import {forwardRef} from 'react';
import Preview from './Preview';
import useSoopiExitMessage from '@/components/soopi//hooks/useSoopiExitMessage'; // 경로에 맞게 조정
import {sendPostMessage} from '@/components/soopi/hooks/useSearchInpFocus';

import styles from '@/components/soopi/styles.module.css';

const SoopiPreviewModal = forwardRef(({data, handleClose}, ref) => {
  const {sendSoopiExitMessage} = useSoopiExitMessage();
  const handleCloseClick = async () => {
    try {
      if (data.broadType === 'VOD') {
        await sendSoopiExitMessage();
      }
      handleClose();
      sendPostMessage('close_preview');
    } catch (e) {
      console.error('닫기 실패:', e);
    }
  };
  return (
    <div className={styles['modal-container']}>
      <Preview
        $streamerName={data?.$streamerName}
        broadType={data?.broadType}
        broadUrl={data?.broadUrl}
        handleClose={handleCloseClick}
        data={data.data}
      />
    </div>
  );
});

SoopiPreviewModal.displayName = 'SoopiPreviewModal';

export default SoopiPreviewModal;
